import React from 'react';
import { Icon } from './Icon.js';
export const IconMapFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M5.5,2.149l-3.129,.695c-.807,.179-1.371,.882-1.371,1.708V13.003c0,.534,.239,1.031,.655,1.365s.953,.46,1.475,.343l2.371-.526V2.149Z", fill: "currentColor" }),
        React.createElement("polygon", { points: "11 3.679 7 2.224 7 14.321 11 15.776 11 3.679", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M16.345,3.632c-.416-.334-.953-.46-1.475-.343l-2.371,.526V15.851l3.129-.695c.807-.179,1.371-.882,1.371-1.708V4.997c0-.534-.239-1.031-.655-1.365Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconMapFill18.js.map